import TipoSangreService from "@/api/services/cobranza/nomencladores/TipoSangreService"
import Vue from "vue"

const state = () => ({
    sangres: [],
    pagination: {
        descending: false,
        page: 1,
        rowsPerPage: 10,
        sortBy: "tipo",
        rowsPerPageItems: [5, 10, 20, 30, 40, 50]
    }
})

const getters = {
    SANGRES: state => {
        return state.sangres
    },
    SANGRES_PAG: state => {
        return state.pagination
    }
}

const mutations = {
    SET_SANGRES: (state, payload) => {
        state.sangres = payload
    },

    SET_SANGRES_PAG: (state, payload) => {
        state.pagination = payload
    },

    ADD_SANGRE: (state, payload) => {
        state.sangres.push(payload)
    },

    UPDATE_SANGRE: (state, payload) => {
        state.sangres = state.sangres.map(el => (el.id === payload.id ? payload : el))
    },

    DELETE_SANGRE: (state, payload) => {
        state.sangres = state.sangres.filter(el => el.id !== payload.id)
    }
}

const actions = {
    LOAD_SANGRES: async ({ commit, state }, { filter, sangreEstado }) => {
        try {
            let pagination = {
                page: state.pagination.page,
                rowsPerPage: state.pagination.rowsPerPage,
                sortBy: state.pagination.descending ? "-" + state.pagination.sortBy : state.pagination.sortBy
            }
            let { data, status, headers } = await TipoSangreService.get({ filter, sangreEstado, ...pagination })
            if (status === 200) {
                commit("SET_SANGRES", data)
                return parseInt(headers["x-pagination-total-count"])
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se han podido cargar los tipos de sangre, inténtelo nuevamente"
            })
        }
    },

    LOAD_ALL_SANGRES: async ({ commit }) => {
        try {
            let { data, status } = await TipoSangreService.getAll()
            if (status === 200) {
                commit("SET_SANGRES", data)
                return data
            }
        } catch (error) {
            if (error.response) {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    LOAD_ALL_RECORDS_SANGRES: async ({ commit }) => {
        try {
            let { data, status } = await TipoSangreService.getAllRecords()
            if (status === 200) {
                commit("SET_SANGRES", data)
                return null
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se han podido cargar los tipos de sangre, inténtelo nuevamente"
            })
        }
    },

    LOAD_HISTORY_SANGRE: async ({ commit }, payload) => {
        try {
            let { data, status } = await TipoSangreService.getHistory(payload)
            if (status === 200) {
                commit("UPDATE_SANGRE", data)
            }
            return null
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se ha podido cargar el historial del tipo de sangre, inténtelo nuevamente"
            })
        }
    },

    ADD_SANGRE: async ({ commit }, payload) => {
        try {
            let { data, status } = await TipoSangreService.post(payload)
            if (status === 201) {
                commit("ADD_SANGRE", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Agregando",
                    text: "El tipo de sangre ha sido agregado satisfactoriamente"
                })
            }
            return null
        } catch (error) {
            if (!error.response) {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se ha podido agregar el tipo de sangre, inténtelo nuevamente"
                })
            } else {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    UPDATE_SANGRE: async ({ commit }, payload) => {
        try {
            let { data, status } = await TipoSangreService.put(payload)
            if (status === 200) {
                commit("UPDATE_SANGRE", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Modificando",
                    text: "El tipo de sangre ha sido modificado satisfactoriamente"
                })
            }
            return null
        } catch (error) {
            if (!error.response) {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se ha podido modificar el tipo de sangre, inténtelo nuevamente"
                })
            } else {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    DELETE_SANGRE: async ({ commit }, payload) => {
        try {
            let { status, data } = await TipoSangreService.delete(payload)
            if (status === 204) {
                commit("DELETE_SANGRE", payload)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Eliminando",
                    text: "El tipo de sangre ha sido eliminado satisfactoriamente"
                })
            }
            if (status === 200) {
                commit("UPDATE_SANGRE", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Deshabilitando",
                    text: "El tipo de sangre ha sido deshabilitado satisfactoriamente"
                })
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se ha podido eliminar/deshabilitar el tipo de sangre, inténtelo nuevamente"
            })
        }
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}
